import { AxiosError } from 'axios';

export const responseInError = (error: unknown) => {
  if (error instanceof AxiosError && error.response?.data?.message) {
    error.message = error.response.data.message;
  }

  return Promise.reject(error);
};
